import { DigitizingOrdersApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useDigitizingOrders = (userId: string) => {
  const [digitizingOrders] = useAPIAction(
    DigitizingOrdersApi,
    // WHAT: fetches this user's  orders.
    // WHY a parameter instead of a hardcoded `true`: `allUserOrders` maps
    // straight to the API's `all_user_orders` flag. It used to always be
    // `true`, which meant every user (sub-user or not) silently got back
    // their parent account's full order list on first load. Now the
    // caller decides — DigitizingOrderWorkspace defaults it to `false` and only
    // flips it to `true` when the rep explicitly ticks "Show all orders"
    // for a sub-user.
    async (api, allUserOrders?: boolean) => {
      let response = await api.digitizingOrdersGetList({
        limit: 9999,
        offset: 0
      });
      return {
        successMessages: [],
        data: response,
      };
    },
    {
      defaultApiConfigOptions: {
        impersonationForId: userId
      },
      translationPrefix: "",
    }
  );
  return useCallback(async (allUserOrders?: boolean) => {
    return await digitizingOrders(allUserOrders);
  }, [digitizingOrders]);
};
